// removed by extract-text-webpack-plugin
module.exports = {"root":"SearchMapPriceLabel__root__1vBNp","priceLabel":"SearchMapPriceLabel__priceLabel__tnfPq","caret":"SearchMapPriceLabel__caret__2CV4r","priceLabelActive":"SearchMapPriceLabel__priceLabelActive__3rshp","caretShadow":"SearchMapPriceLabel__caretShadow__3GiBU","caretActive":"SearchMapPriceLabel__caretActive__3KLso"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchMapPriceLabel/SearchMapPriceLabel.css
// module id = 2098
// module chunks = 0